<template>
    <div class="outer-content" v-bind:key="'resizeCounter' + resizeCounter">

        <GameBackground :ownedPropertyValue="ownedPropertyValue" :myOwnedProperty="myOwnedProperty"
            :fadeOutStorm="fadeOutStorm" :bankBalance="bankBalance" :game="game" :playerState="playerState"
            :showStopBank="!natureBasedSelected && (stopBankSelected || playerState.stopBank)" :subMenu="subMenu"
            :natureBasedState="natureBasedState" :natureBasedSea="natureBasedSea"
            :boundKey="'backgroundUpdates' + updates + '_' + internalUpdates" :user="user" :riverStage="riverStage"
            :riverAndSeaHints="howToPlay == 2" :hasRiverOverlay="hasRiverOverlay" :hasSeaOverlay="hasSeaOverlay"
            :noHighFloods="noHighFloods" :round="playerState.round" :stormStage="stormStage" :stormZone="stormZone"
            :seaZone="seaZone" :seawallHeight="seaWallHeight" :seaWallZone="seaWallZone"
            :groundWaterZone="groundWaterZone" :properties="properties" :playAudio="playAudio"
            :drainagePumpSelected="drainagePumpSelected">
        </GameBackground>

        <!-- Main UI overlay is aligned to edges rather than the center safe zone -->
        <div class="outer-content">

            <DashboardHeader v-if="howToPlay >= 3" :class="{ 'force-to-front': howToPlay == 3 }" @cheat="cheat"
                :ownedPropertyValue="ownedPropertyValue" :bankBalance="bankBalance" :isMarae="isMarae" :user="user"
                class="myUser" @open-donate="donateBox = true" :showDonate="offline == false" :slideIn="true">
                <div v-if="howToPlay == 3" class="hint-indicator-3"></div>
            </DashboardHeader>

            <div :class="{ 'force-to-front': howToPlay == 0 }" class="guide-outer">
                <Simplebar data-simplebar-auto-hide="false" class="simple-bar">
                    <div>
                        {{ debugGameState }}
                    </div>
                </Simplebar>
                <div class="guide-inner" :class="{ 'guide-inner-animate-immediately': daraNodImmediate }"
                    v-bind:key="'daraNod' + daraNod">
                </div>
                <div v-if="howToPlay == 0" class="hint-indicator-0"></div>
                <div @click="progressGame" class="btn-storm" v-if="playerState.roundState == roundstates.Storm"
                    v-html='T("button_next")'>
                </div>
                <div class="guide-about-area" @click="$emit('show-about')"></div>
            </div>

            <!--playerState.roundState == roundstates.ChooseOption && -->

            <div class="control-panel"
                v-if="howToPlay > 0 && !choiceConflictText && (playerState.roundState == roundstates.ChooseOption) || (playerState.roundState == roundstates.RoundReport)"
                :class="{ 'force-to-front': howToPlay == 1, 'no-click': howToPlay == 1 }">
                <div class="control-panel-action-text" v-html="T('actions')"></div>
                <div class="control-panel-button-container" :class="controlPanelContainerClass">
                    <template v-for="(button, buttonId) in buttons">
                        <b-button @click="button.action()" :class="button.class()" v-bind:key="'button' + buttonId">
                            <div class="button-name">{{ button.name }}</div>
                            <div class="button-value"><span v-if="button.valueString()">{{
                                button.valueString()
                                    }}</span></div>
                        </b-button>
                    </template>
                </div>
                <div v-if="isSubMenu" class="control-panel-confirm-back-container">
                    <b-button @click="confirmClicked(false)"
                        :class="canConfirm ? 'control-panel-confirm-button' : 'control-panel-confirm-button-disabled'"
                        v-html="T('button_Confirm')"></b-button>
                    <b-button @click="backClicked" class="control-panel-back-button"
                        v-html="T('button_Back')"></b-button>
                </div>
                <div class="control-panel-hazard-map"
                    :class="{ 'force-to-front': howToPlay == 2, 'no-click': howToPlay == 2 }">
                    <div class="hazard-toggle-river" :class="{ 'hazard-toggle-on': hasRiverOverlay || howToPlay == 2 }"
                        @click="hasRiverOverlay = !hasRiverOverlay"></div>
                    <div class="hazard-toggle-sea" :class="{ 'hazard-toggle-on': hasSeaOverlay || howToPlay == 2 }"
                        @click="hasSeaOverlay = !hasSeaOverlay"></div>
                    <div v-if="howToPlay == 2" class="hint-indicator-2-a"></div>
                    <div v-if="howToPlay == 2" class="hint-indicator-2-b"></div>
                    <div class="control-panel-hazard-map-header" v-html="T('hazard_maps')"></div>
                    <div class="control-panel-hazard-map-sea" v-html="T('sea')"></div>
                    <div class="control-panel-hazard-map-river" v-html="T('river')"></div>
                    <div class="control-panel-hazard-map-info"
                        @click="showHazardMapHelp = true; hasRiverOverlay = true; hasSeaOverlay = true"></div>
                </div>
                <div v-if="howToPlay == 1" class="hint-indicator-1"></div>
            </div>
            <div class="slr" :class="slrClass"></div>

        </div>

        <template v-if="hidePopups == false && tutorialComplete">

            <DonateBox v-if="donateBox" @onclose="closeDonation" :bankBalance="bankBalance" :user="user" :game="game"
                @on-donate="onDonate">
            </DonateBox>

            <DialogueBox v-else-if="donation" :blur="true" :left="438" :top="384" :width="404" :height="250">
                <div class="donation-received-inner">
                    <div class="donation-received-header" v-html="T('donation_received_header')"></div>
                    <div class="donation-received-text" v-html="donationReceivedText"></div>
                    <div class="donation-received-btn" @click="$emit('dismiss-donation')" v-html="T('button_close')">
                    </div>
                </div>
                <div class="facilitator-circle-donation-received"></div>
                <div class="facilitator-tick facilitator-tick-donation-received"></div>"
            </DialogueBox>

            <DialogueBoxVoteResult v-else-if="showNatureBasedResult || showStopBankResult"
                :isNatureBased="showNatureBasedResult" :yesVotes="yesVotes" :noVotes="noVotes"
                :natureBasedVoteType="natureBasedVoteType" :stopBankVoteType="stopBankVoteType"
                @dismissed-vote-results="dismissVoteResult()">
            </DialogueBoxVoteResult>

            <RoundResults v-else-if="showRoundReport" :playerState="playerState" :offline="offline" :game="game"
                :canProgress="true" @roll-dice="progressGame()">
            </RoundResults>

            <RepairPopUp v-else-if="showRepairPopUp" :riverStage="riverStage" :playerState="playerState"
                :isOverdue="isOverdue" @next-clicked="progressGame()" :isMarae="isMarae" :isFarm="isFarm"></RepairPopUp>

            <CalendarPopUp v-else-if="playerState.roundState == roundstates.Calendar" :isMuted="isMuted"
                :playerState="playerState" :game="game" @next-clicked="progressGame()">
            </CalendarPopUp>

            <DiceRollPopUp :isMuted="isMuted" :round="playerState.round" :isHost="isHost"
                @river-state-cheat="riverStateCheat" @storm-state-cheat="stormStateCheat" :riverStage="riverStage"
                :stormStage="stormStage" v-else-if="playerState.roundState == roundstates.RollTheDice"
                @next-clicked="progressGame()" :diceResultText="diceResultText">
            </DiceRollPopUp>

            <DialogueStopBankVote v-else-if="stopBankVoteRequested || natureBasedVoteRequested"
                :stopBankVoteType="stopBankVoteType" :natureBasedVoteType="natureBasedVoteType"
                :NatureBasedVote="natureBasedVoteRequested" :CanVote="bankBalance >= voteCost" :Cost="voteCost"
                :GovernmentContribution="voteCostGovernment" :bankBalance="bankBalance" @on-vote="OnVote"
                :myUser="myUser" :game="game" :playerState="playerState">
            </DialogueStopBankVote>

            <div v-else-if="showTurnPrompt" class="inner-content force-to-front no-click">
                <TurnPrompt :id="playerTurnId + ''" :round="playerState.round + 1" :isMyTurn="isMyTurn"
                    :isMuted="isMuted" :isWaitingForVote="waitingForVote"></TurnPrompt>
            </div>

        </template>

        <!-- multiplayer prompts -->
        <div class="outer-content no-click">

            <div class="chat-offset yes-click" v-if="showChat">
                <div class="chat-tick"></div>
                <vue-advanced-chat v-bind:key="'advancedChatKey' + advancedChatCount" :current-user-id="chatUser"
                    :rooms="JSON.stringify(rooms)" :messages="JSON.stringify(messages)"
                    :link-options="JSON.stringify(linkOptions)" :auto-scroll="JSON.stringify(autoScroll)"
                    :room-actions="JSON.stringify(roomActions)" loading-rooms="false" rooms-loaded="true"
                    show-add-room="false" show-search="false" show-add="false" show-files="false" show-audio="false"
                    height="380px" :messages-loaded="messagesLoaded" @send-message="p => $emit('send-message', p)"
                    :message-actions="JSON.stringify(messageActions)" :text-messages="JSON.stringify(textMessages)"
                    single-room="true" emoji-data-source="./emoji.json" :styles="chatStyles" />
                <div class="close-chat-btn" @click="$emit('on-hide-chat')"></div>
            </div>

        </div>

        <!-- How to play, always show the cover if we haven't exhausted all hints yet -->
        <div v-if="tutorialComplete == false" class="how-to-play-cover">
        </div>

        <DialogueBox class="force-to-front" v-if="howToPlay == 0" :width="512" :height="362" :left="315" :top="265">
            <div class="facilitator-circle-0"></div>
            <div class="facilitator-tick facilitator-tick-0"></div>
            <div class="facilitator-header-left" v-html="T('How_To_Play_1_Heading')"></div>
            <div class="facilitator-header-right"
                v-html="T(offline ? 'How_To_Play_Hint_1_Singleplayer' : 'How_To_Play_Hint_1')"></div>
            <div class="facilitator-text" v-html="T('How_To_Play_1b')"></div>
            <div class="facilitator-next-btn" v-html="T('button_continue')" @click="nextHint"></div>
            <div class="facilitator-skip-btn" v-html="T('button_skip_how_to_play')" @click="completeHints"></div>
        </DialogueBox>

        <DialogueBox v-if="howToPlay == 1" :width="404" :height="250" :left="27" :top="320">
            <div class="facilitator-circle-1"></div>
            <div class="facilitator-tick facilitator-tick-1"></div>
            <div class="facilitator-header-left" v-html="T('How_To_Play_2_Heading')"></div>
            <div class="facilitator-header-right"
                v-html="T(offline ? 'How_To_Play_Hint_2_Singleplayer' : 'How_To_Play_Hint_2')"></div>
            <div class="facilitator-text" v-html="T('How_To_Play_2')"></div>
            <div class="facilitator-next-btn" v-html="T('button_continue')" @click="nextHint"></div>
            <div class="facilitator-skip-btn" v-html="T('button_skip_how_to_play')" @click="completeHints"></div>
        </DialogueBox>

        <DialogueBox class="force-to-front" v-if="howToPlay == 2" :width="512" :height="362" :left="190" :top="462">
            <div class="facilitator-circle-2"></div>
            <div class="facilitator-tick facilitator-tick-2"></div>
            <div class="facilitator-header-left" v-html="T('How_To_Play_3_Heading')"></div>
            <div class="facilitator-header-right"
                v-html="T(offline ? 'How_To_Play_Hint_3_Singleplayer' : 'How_To_Play_Hint_3')"></div>
            <div class="facilitator-text" v-html="T('How_To_Play_3')"></div>
            <div class="facilitator-next-btn" v-html="T('button_continue')" @click="nextHint"></div>
            <div class="facilitator-skip-btn" v-html="T('button_skip_how_to_play')" @click="completeHints"></div>
        </DialogueBox>


        <DialogueBox v-if="howToPlay == 3" :width="512" :height="362" :left="214" :top="75">
            <div class="facilitator-circle-3"></div>
            <div class="facilitator-tick facilitator-tick-3"></div>
            <div class="facilitator-header-left" v-html="T('How_To_Play_4_Heading')"></div>
            <div class="facilitator-header-right"
                v-html="T(offline ? 'How_To_Play_Hint_4_Singleplayer' : 'How_To_Play_Hint_4')"></div>
            <div class="facilitator-text" v-html="T(isMarae ? 'How_To_Play_4_Marae' : 'How_To_Play_4')"></div>

            <div v-if="offline" class="facilitator-next-btn" v-html="T('start_game')" @click="completeHints"></div>


            <div v-if="offline == false" class="facilitator-next-btn" v-html="T('button_continue')" @click="nextHint">
            </div>
            <div v-if="offline == false" class="facilitator-skip-btn" v-html="T('button_skip_how_to_play')"
                @click="completeHints"></div>
        </DialogueBox>

        <DialogueBox v-if="howToPlay == 4 && offline == false" :width="512" :height="362" :left="527" :top="59">
            <div class="facilitator-circle-4"></div>
            <div class="facilitator-tick facilitator-tick-4"></div>
            <div class="facilitator-header-left" v-html="T('How_To_Play_5_Heading')"></div>
            <div class="facilitator-header-right" v-html="T('How_To_Play_Hint_5')"></div>
            <div class="facilitator-text" v-html="T('How_To_Play_5')"></div>
            <div class="facilitator-next-btn" v-html="T('start_game')" @click="completeHints"></div>
        </DialogueBox>

        <div v-if="howToPlay == 4 && offline == false" class="hint-indicator-4"></div>

        <DialogueBox v-if="choiceConflictText" :width="404" :height="278.42" :left="433" :top="319.46">
            <div class="facilitator-circle-choice-conflict"></div>
            <div class="facilitator-tick facilitator-tick-choice-conflict"></div>
            <div class="facilitator-header-left" v-html="T('hey_there')"></div>
            <div class="facilitator-text" v-html="choiceConflictText"></div>
            <div class="facilitator-next-btn" v-html="T('button_continue')" @click="resolveChoiceConflict(true)"></div>
            <div class="facilitator-skip-btn" v-html="T('button_back')" @click="resolveChoiceConflict(false)"></div>
        </DialogueBox>

        <DialogueBox v-if="showHazardMapHelp" class="no-click" :width="497" :height="290" :top="315" :left="715">
            <div class="hazard-map-help-inner">
                <div class="hazard-map-help-inner-header" v-html="T('How_To_Play_3_Heading')"></div>
                <div class="hazard-map-help-inner-text" v-html="T('How_To_Play_3')"></div>
            </div>
            <div class="hazard-map-help-close yes-click" @click="showHazardMapHelp = false"></div>
            <div class="facilitator-tick hazard-map-help-tick"></div>
        </DialogueBox>

        <div v-bind:key="playerState.round + 'roundOverlay'"
            v-if="tutorialComplete && playerState.roundState == roundstates.ChooseOption"
            class="outer-content round-overlay-base">

            <div v-if="playerState.round == 0" class="round-1"></div>
            <div v-if="playerState.round == 1" class="round-2"></div>
            <div v-if="playerState.round == 2" class="round-3"></div>
            <div v-if="playerState.round == 3" class="round-4"></div>
            <div v-if="playerState.round == 4" class="round-5"></div>
            <div v-if="playerState.round == 5" class="round-6"></div>
            <div v-if="playerState.round == 6" class="round-7"></div>
            <div v-if="playerState.round == 7" class="round-8"></div>

        </div>

        <!--preloads-->
        <div style="opacity:0;pointer-events:none">
            <div class="round-1"></div>
            <div class="round-2"></div>
            <div class="round-3"></div>
            <div class="round-4"></div>
            <div class="round-5"></div>
            <div class="round-6"></div>
            <div class="round-7"></div>
            <div class="round-8"></div>
        </div>


    </div>
</template>

<script lang="ts">
import room from '@/classes/room';
import Vue, { PropType } from 'vue';
import Game, { riverDamageLevel, stormDamageLevel, allPlayersAtState, currentPlayer, getRiverStage, getSurgeStage, getTotalStormLevel, seaWallZone, seaZone, needsToMoveOutOfSea, } from '../../../shared_fca/game';
import message from '../../../shared_fca/message';
import room_user, { buyProperty, users } from '../../../shared_fca/room_user';
import { T, playerDonation, playerViewState, roundedValue } from '@/App.vue';
import { roundstates, SubMenu } from '../../../shared_fca/enums';
import property, {
    getBuyCost, getSellCost, properties, getStopBankCost, getNatureBasedCost, getMoveCost, getRaiseCost, getRaiseButtonText, getRaiseSelectionText, getMoveButtonText,
    getMoveSelectionText, getSellPropertyButton, getSellPropertyText, getRaisePost, getMovePost, ownedPropertyValue, canBuyOrSellProperty, getRaiseReportText, getMoveReportText, getSellPropertyReport,
    doesAnyoneOwnThisProperty,
    isInMarae,
    isOnFarm,
    groundWaterZone,
    getPumpCost,
    propertyPartIsUnderwater,
    anySalvagablePropertyPart,
    cowShedIsDamaged,
    getValuesMatrix,
} from '../../../shared_fca/property';
import playerState, { doPlayerAction, getRepairCost, isLivingWithRelatives } from '../../../shared_fca/playerstate';
import GameBackground from "../components/GameBackground.vue";

import RoundResults from "../components/RoundResults.vue";
import DialogueStopBankVote from "../components/DialogueStopBankVote.vue";
import DonateBox from "../components/DonateBox.vue";
import RepairPopUp from "../components/RepairPopUp.vue";
import CalendarPopUp from "../components/CalendarPopUp.vue";

import Simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';

import DiceRollPopUp from "../components/DiceRollPopUp.vue";
import propertyState from '../../../shared_fca/propertyState';
import DialogueBoxVoteResult from '@/components/DialogueBoxVoteResult.vue';
import DialogueBox from '@/components/DialogueBox.vue';
import TurnPrompt from '@/components/TurnPrompt.vue';
import DashboardHeader from '@/components/DashboardHeader.vue';
import { maxRounds } from '@/configuration';
import property_part from '../../../shared_fca/property_part';
import propertyPartState from '../../../shared_fca/propertyPartState';

class GameData {
    rooms: room[] = [];
    messagesLoaded = false;
    roomActions = [];
    messageActions = [];
    autoScroll = { send: { new: true, newAfterScrollUp: true }, receive: { new: true, newAfterScrollUp: true } };
    linkOptions = { disabled: true, target: '_self' };
    textMessages = {
        ROOMS_EMPTY: '',
        ROOM_EMPTY: '',
        NEW_MESSAGES: '',
        MESSAGE_DELETED: '',
        MESSAGES_EMPTY: '',
        CONVERSATION_STARTED: '',
        TYPE_MESSAGE: 'Chat here...',
        SEARCH: '',
        IS_ONLINE: '',
        LAST_SEEN: '',
        IS_TYPING: '',
        CANCEL_SELECT_MESSAGE: ''
    };
    selectedButtons: { [id: string]: boolean } = {};
    stopBankSelected = false;
    seawallHeightSelected = 0;
    natureBasedSelected = false;
    natureBasedSeaSelected = false;
    drainagePumpSelected = false;
    subMenu: SubMenu = SubMenu.main;
    internalUpdates = 0;
    properties = properties;
    roundstates = roundstates;
    donateBox = false;
    todoOverrideText = "";
    actionsThisRound = 0;
    iRequestedVote = false;
    resizeCounter = 0;

    hasSeaOverlay = false;
    hasRiverOverlay = false;
    choiceConflictText = "";
    advancedChatCount = 0;

    daraWaitMessage = "";
    daraNod = 0;
    daraNodImmediate = false;
    showHazardMapHelp = false;

    actionsAvailable: string[][] = [];
}


interface buttonState {
    name: string;
    actionKey: string;
    analyticsKey: string;
    class: () => string;
    value: () => number;
    valueString: () => string;
    action: () => void;
    completionAction: () => boolean;
}

export default Vue.extend({
    name: 'MainGame',

    components: {
        GameBackground,
        RoundResults,
        DialogueStopBankVote,
        DonateBox,
        RepairPopUp,
        CalendarPopUp,
        DiceRollPopUp,
        DialogueBoxVoteResult,
        DialogueBox,
        TurnPrompt,
        DashboardHeader,
        Simplebar,
    },

    props: {

        game: Object as PropType<Game>,
        messages: Array as PropType<message[]>,
        user: String,
        offline: Boolean,
        updates: Number,
        isHost: Boolean,

        stopBankVoteRequested: Boolean,
        stopBankVoteType: Number,

        natureBasedVoteRequested: Boolean,
        natureBasedVoteType: Boolean,

        hidePopups: Boolean,
        showChat: Boolean,

        showStopBankResult: Boolean,
        showNatureBasedResult: Boolean,
        yesVotes: Number,
        noVotes: Number,

        donation: Object as PropType<playerDonation | null>,

        myUser: Object as PropType<room_user>,
        playerViewStates: Array as PropType<playerViewState[]>,

        playAudio: Boolean,
        waitingForVote: Boolean,

        newDefaultText: Array as PropType<string[]>,
        isMuted: Boolean,
        maxHints: Number,
        howToPlay: Number,
        cheatEnabled: Boolean,

    },

    watch: {

        debugGameState: function () {

            this.makeDaraNod(true);

        },

        showChat: function () {
            this.resetMessages();
        },

    },

    created() {
        window.addEventListener("resize", this.onResize);
    },
    destroyed() {
        window.removeEventListener("resize", this.onResize);
    },

    computed: {

        tutorialComplete: {
            cache: false,
            get(): boolean {
                return this.howToPlay >= this.maxHints;
            }
        },

        noHighFloods: {
            cache: false,
            get(): boolean {
                return this.playerState.natureBasedState >= 1 || this.playerState.stopBank || this.stopBankSelected;
            }
        },

        seaZone: {
            cache: false,
            get(): number {
                return seaZone(this.playerState, false, this.seaWallHeight);
            }
        },

        groundWaterZone: {
            cache: false,
            get(): number {
                return groundWaterZone(this.playerState, false);
            }
        },

        seaWallZone: {
            cache: false,
            get(): number {
                return seaWallZone(this.playerState);
            }
        },

        seaWallHeight: {
            cache: false,
            get(): number {
                // Visual sea wall height
                if (this.natureBasedSeaSelected) {
                    return 0; //We're going to tear down the wall
                }
                if (this.seawallHeightSelected) {
                    return this.seawallHeightSelected;
                }
                // Logical sea wall height
                return this.playerState.seaWallHeight;
            }
        },

        isSubMenu: {
            cache: false,
            get(): boolean {
                return this.subMenu != SubMenu.main;
            }
        },

        controlPanelContainerClass: {
            cache: false,
            get(): object {
                return {
                    'control-panel-submenu': this.isSubMenu,
                };
            }
        },

        slrClass: {
            cache: false,
            get(): string {
                return "slr-" + (this.playerState.round + 1);
            }
        },

        myOwnedProperty: {
            cache: false,
            get(): property {
                return properties[this.playerState.livedInProperty];
            }
        },

        chatStyles: {
            cache: false,
            get(): string {
                return JSON.stringify(
                    {
                        header: {
                            background: '#636252',
                            colorRoomName: '#FFFFFF',
                        },
                        footer: {
                            background: '#ffffff9e'
                        },
                        content: {
                            background: '#ffffff9e'
                        },
                        emoji: {
                            right: "0px: !important"
                        }
                    }
                );
            }
        },

        chatUser: {
            cache: false,
            get(): string {
                return T(users[this.user].realname);
            }
        },

        donationReceivedText: {
            cache: false,
            get(): string {

                if (!this.donation) {
                    return "";
                }

                let result = T('donation_received_text');
                return result.replace("###", this.donation.name).replace("$$$", this.donation.amount.toString());
            }
        },

        SVGLeft: {
            cache: false,
            get(): number {
                const adjustedHeight = window.innerHeight / 1024;
                const adjustedWidth = window.innerWidth / adjustedHeight;
                return Math.max(0, (adjustedWidth - 1366) / 2);
            },
        },


        isMarae: {
            cache: false,
            get(): boolean {
                return isInMarae(this.playerState);
            }
        },

        cowShedNeedsRepair: {
            cache: false,
            get(): boolean {

                return cowShedIsDamaged(this.playerState);
            }
        },

        isFarm: {
            cache: false,
            get(): boolean {
                return isOnFarm(this.playerState);
            }
        },

        isMyTurn: {
            cache: false,
            get(): boolean {
                return this.user == currentPlayer(this.game).toString();
            }
        },


        playerTurnId: {
            cache: false,
            get(): number {
                return currentPlayer(this.game);
            }
        },

        showRepairPopUp: {
            cache: false,
            get(): boolean {

                return this.playerState.roundState == roundstates.Repair;
            }
        },

        voteCost: {
            cache: false,
            get(): number {
                if (this.natureBasedVoteRequested) {
                    return getNatureBasedCost(this.playerState, this.natureBasedVoteType, this.game.governmentSubsidy);
                }
                else {
                    return this.stopBankCost(this.stopBankVoteType, false, this.game.governmentSubsidy);
                }
            }
        },

        voteCostGovernment: {
            cache: false,
            get(): number {

                let fullCost = 0;
                if (this.natureBasedVoteRequested) {
                    fullCost = getNatureBasedCost(this.playerState, this.natureBasedVoteType, false);
                }
                else {
                    fullCost = this.stopBankCost(this.stopBankVoteType, false, false);
                }

                //Return the difference between what the WHOLE solution would cost, and how much the government are covering
                return fullCost - this.voteCost;

            }
        },

        isOverdue: {
            cache: false,
            get(): boolean {
                return this.playerState.isOverdue;
            }
        },

        repairCost: {
            cache: false,
            get(): number {
                return getRepairCost(this.playerState);
            }
        },

        needsRepair: {
            cache: false,
            get(): boolean {
                return this.repairCost > 0;
            }
        },

        natureBasedSea: {
            cache: false,
            get(): boolean {
                //Never show nature based sea IF we are selecting a seawall (but we can replace a seawall with a nature based solution)
                if (this.seawallHeightSelected) {
                    return false;
                }
                return this.natureBasedSeaSelected || this.playerState.natureBasedSeaSolution;
            }
        },

        natureBasedState: {
            cache: false,
            get(): number {

                if (this.stopBankSelected) {
                    return 0;
                }

                let result = 0;
                if (this.natureBasedSelected || this.playerState.isMakingNatureBasedSolution) {
                    result = 1;
                }
                return Math.max(result, this.playerState.natureBasedState);

            }
        },

        playerState: {
            cache: false,
            get(): playerState {
                return this.game.playerStates[this.user];
            }
        },

        availableCash: {
            cache: false,
            get(): number {

                let result = this.bankBalance;

                //If there's no selected buttons, just return the result
                let anySelected = false;
                for (const selected of Object.values(this.selectedButtons)) {
                    if (selected) {
                        anySelected = true;
                    }
                }

                if (anySelected) {
                    for (let i = 0; i < this.buttons.length; i++) {
                        if (this.selectedButtons[i]) {
                            result -= this.buttons[i].value();
                        }
                    }
                }

                return result;

            }
        },

        //Not needed any more since it's not possible to select a move as well as a nature based solution
        /*
        disableNatureBasedSolution: {
            cache: false,
            get(): boolean {

                //We want to disable the nature based solution if any nature based buttons are selected this turn
                for (const property of this.playerState.properties) {
                    let propertyData = properties[property.property];

                    for (let i = 0; i < propertyData.property_parts.length && i < property.propertyPartStates.length; i++) {
                        let propertyPartData = propertyData.property_parts[i];

                        if (propertyPartData.moveSelected && getNatureBasedMove(propertyPartData)) {
                            return true;
                        }



                    }
                }

                return false;
            }
        },
        */

        riverStage: {
            cache: false,
            get(): number {
                return getRiverStage(this.game, this.playerState);
            }
        },

        stormStage: {
            cache: false,
            get(): number {
                return getSurgeStage(this.game, this.playerState);
            }
        },

        stormZone: {
            cache: false,
            get(): number {
                return getTotalStormLevel(this.game, this.playerState);
            }
        },

        fadeOutStorm: {
            cache: false,
            get(): boolean {
                return ((this.playerState.roundState == roundstates.RollTheDice
                    || this.playerState.roundState == roundstates.Repair
                    || this.playerState.roundState == roundstates.Storm
                    || this.playerState.roundState == roundstates.Calendar) == false);
            }
        },

        natureBasedCost: {
            cache: false,
            get(): number {

                //Calculate the total cost for the nature based solution
                let result = getNatureBasedCost(this.playerState, false, this.game.governmentSubsidy);
                return result;

            }
        },

        buttons: {
            cache: false,
            get(): buttonState[] {

                const result = this.availableButtons();

                //Disable all buttons if not our turn
                if (this.canProgress == false || this.isMyTurn == false) {
                    for (const button of result) {
                        button.class = () => "selection-button-disabled";
                    }
                }

                return result;
            }
        },

        canConfirm: {
            cache: false,
            get(): boolean {
                if (Object.keys(this.selectedButtons).length == 0 && this.playerState.roundState == roundstates.ChooseOption) {
                    return false;
                }
                return true;
            }
        },

        canGoBack: {
            cache: false,
            get(): boolean {
                return this.buyMode;
            }
        },

        buyMode: {
            cache: false,
            get(): boolean {
                return this.subMenu != SubMenu.main;
            }
        },

        showRoundReport: {
            cache: false,
            get(): boolean {
                return this.playerState.roundState == roundstates.RoundReport && allPlayersAtState(this.game, this.playerState.round, roundstates.RoundReport);
            }
        },

        showTurnPrompt: {
            cache: false,
            get(): boolean {

                if (this.offline || this.hidePopups) {
                    return false; //NEVER show the prompt if we're offline or in the middle of the tutorial
                }

                return this.playerState.roundState == roundstates.ChooseOption //If it's our turn
                    //If it's not our turn, but we're not showing the round report yet
                    || (this.playerState.roundState == roundstates.RoundReport
                        && allPlayersAtState(this.game, this.playerState.round, roundstates.RoundReport) == false);
            }
        },

        canProgress: {
            cache: false,
            get(): boolean {

                //We can never progress if we're waiting for a vote
                if (this.waitingForVote) {
                    return false;
                }

                //If we're on choose option, we can only progress if we're 
                if (this.playerState.roundState == roundstates.ChooseOption) {
                    return this.isMyTurn;
                }

                //Can confirm button should be false otherwise
                return false;
            }
        },

        diceResultText: {
            cache: false,
            get(): string {

                switch (this.riverStage) {
                    case riverDamageLevel.none:
                        switch (this.stormStage) {
                            case stormDamageLevel.level1:
                                return T("roll_flood_text_result_1");
                            case stormDamageLevel.level2:
                                return T("roll_flood_text_result_2");
                            case stormDamageLevel.cyclone:
                                return T("roll_flood_text_result_3");
                        }
                        break;

                    case riverDamageLevel.highFlood:
                        switch (this.stormStage) {
                            case stormDamageLevel.level1:
                                return T("roll_flood_text_result_4");
                            case stormDamageLevel.level2:
                                return T("roll_flood_text_result_5");
                            case stormDamageLevel.cyclone:
                                return T("roll_flood_text_result_6");
                        }
                        break;

                    case riverDamageLevel.severeFlood:
                        switch (this.stormStage) {
                            case stormDamageLevel.level1:
                                return T("roll_flood_text_result_7");
                            case stormDamageLevel.level2:
                                return T("roll_flood_text_result_8");
                            case stormDamageLevel.cyclone:
                                return T("roll_flood_text_result_9");
                        }
                        break;
                }

                //unknown/none
                return "";
            }
        },

        livingWithRelatives: {
            cache: false,
            get(): boolean {
                return isLivingWithRelatives(this.playerState);
            }
        },

        debugGameState: {
            cache: false,
            get(): string {

                if (this.howToPlay < this.maxHints) {
                    return T("How_To_Play_1");
                }
                switch (this.playerState.roundState) {

                    case roundstates.RoundReport:
                        return this.daraWaitMessage;

                    case roundstates.Storm:
                        return this.diceResultText;

                    case roundstates.ChooseOption:

                        //Is our cowshed damaged?
                        if (this.cowShedNeedsRepair) {
                            if (this.repairCost > this.bankBalance) {
                                //We can't repair our farm, we're basically stuffed
                                return T("dara_farm_cannotrepair_damagedcowshed");
                            }
                            //We can repair our farm, that's the only thing we can do 
                            return T("dara_farm_forcedrepairs_damagedcowshed");
                        }

                        //Are we moved in with relatives?
                        if (this.livingWithRelatives) {
                            //Mangroves?
                            if (this.playerState.natureBasedSeaSolution) {
                                return T("mangroves_property_boundary_next_round");
                            }
                            return T("forced_city_move_next_round");
                        }

                        if (needsToMoveOutOfSea(this.playerState, true)) {
                            //Mangroves?
                            if (this.playerState.natureBasedSeaSolution) {

                                if (this.isFarm) {
                                    return T("mangroves_property_boundary_farm");
                                }
                                else {
                                    if (this.canAffordAnyProperty()) {
                                        return T("mangroves_property_boundary_sell_and_move");
                                    }
                                    return T("mangroves_property_boundary");
                                }

                            }
                            else {
                                if (this.isFarm) {
                                    return T("forced_city_move_farm");
                                }
                                return T("forced_city_move");
                            }
                        }

                        if (this.needsRepair) {
                            if (this.isFarm) {
                                return T("make_repairs_farm_unable_to_afford");
                            }
                            else if (this.isMarae) {
                                return T("make_repairs_marae_unable_to_afford");
                            }
                            else {
                                return T("tui_unable_to_repair");
                            }
                        }
                        break;

                }

                let seaOrMangrovesAtfarm = false;
                const currentSeaZone = seaZone(this.playerState, true);
                const propertyValues = getValuesMatrix(properties[this.playerState.livedInProperty]);
                if (propertyValues) {
                    const zone = parseInt(propertyValues.Zone, 10);
                    seaOrMangrovesAtfarm = (currentSeaZone >= zone - 1) && this.isFarm;
                }


                if (this.todoOverrideText != "") {
                    return this.todoOverrideText;
                }
                else if (this.subMenu == SubMenu.raiseABuilding) {
                    return T("raise_a_building_dara");
                }
                else if (this.subMenu == SubMenu.relocateABuilding) {
                    if (anySalvagablePropertyPart(this.playerState)) {
                        return T("salvage_rebuild_dara");
                    }
                    return T("relocate_a_building_dara");
                }
                else if (this.subMenu == SubMenu.protectPropertiesAndCommunity) {
                    return T("protect_properties_and_community_dara");
                }
                else if (this.subMenu == SubMenu.relocateUrupa) {
                    return T("relocate_urupa_dara");
                }
                else if (this.subMenu == SubMenu.protectPropertiesAndCommunityRiver) {
                    return T("protect_from_river_floods_dara");
                }
                else if (this.subMenu == SubMenu.protectPropertiesAndCommunitySea) {
                    return T("protect_from_storm_surges_dara");
                }
                else if (this.subMenu == SubMenu.sellAndMove) {
                    return this.pickText("", "sell_and_move_Dara_farm", "choice_8_tui_town");
                }
                else if (this.subMenu == SubMenu.sellAndMoveElsewhere) {
                    return this.pickText("", "choice_10_tui_farm", "choice_9_tui_town");
                }

                /*
                else if (this.subMenu == SubMenu.buyInvestmentProperty) {
                    if (this.isMarae) {
                        return T("choice_7_tui_marae");
                    }
                    else if (this.isFarm) {
                        return T("choice_6_tui_farm");
                    }
                    else {
                        return T("choice_4_tui_town");
                    }
                }
                else if (this.subMenu == SubMenu.sellAndMove || this.subMenu == SubMenu.sellAndMoveElsewhere) {
                    if (this.isFarm) {
                        return T("choice_7_tui_farm");
                    }
                    else {
                        return T("choice_5_tui_town");
                    }
                }
                    */

                else if (this.playerState.seaWallDestroyedHeight == 2) {
                    //Special handling for the stop bank being destroyed
                    return T("seawall_2_destroyed_tui").replace("###", roundedValue(this.playerState.display_income));
                }

                else if (this.playerState.seaWallDestroyedHeight == 1) {
                    //Special handling for the stop bank being destroyed
                    return T("seawall_1_destroyed_tui").replace("###", roundedValue(this.playerState.display_income));
                }

                else if (this.playerState.natureBasedSeaDestroyed) {
                    //Special handling for the stop bank being destroyed
                    return T("nature_based_sea_destroyed_tui").replace("###", roundedValue(this.playerState.display_income));
                }
                else if (this.playerState.stopBankDestroyed) {
                    //Special handling for the stop bank being destroyed
                    return T("stop_bank_destroyed_tui").replace("###", roundedValue(this.playerState.display_income));
                }
                else if (seaOrMangrovesAtfarm) {

                    if (this.playerState.natureBasedSeaSolution) {
                        return T('mangroves_on_farm');
                    }
                    else {
                        return T('water_on_farm');
                    }

                }
                else if (this.newDefaultText[this.playerState.round]) {
                    return this.newDefaultText[this.playerState.round];
                }
                else if (this.isMarae) {
                    return T('Generic_Tui_Speech_Bubble_Marae');
                }
                else if (this.isFarm) {
                    return T('Generic_Tui_Speech_Bubble_Farm');
                }
                else {
                    return T('Generic_Tui_Speech_Bubble_Town');
                }
            }
        },

        livedInPropertyCost: {
            cache: false,
            get(): number {
                return getSellCost(this.playerState, this.livedInPropertyState);
            }
        },

        ownedPropertyValue: {
            cache: false,
            get(): number {
                return ownedPropertyValue(this.playerState);
            }
        },

        canSell: {
            cache: false,
            get(): boolean {
                return this.livedInPropertyCost > 0;
            }
        },


        livedInPropertyState: {
            cache: false,
            get(): propertyState {
                let index = 0;
                for (let i = 1; i < this.playerState.properties.length; i++) {
                    if (this.playerState.livedInProperty == this.playerState.properties[i].property) {
                        index = i;
                    }
                }
                return this.playerState.properties[index];
            }
        },

        bankBalance: {
            cache: false,
            get(): number {
                return this.playerState.bankBalance;
            },
            set(value: number): void {
                this.playerState.bankBalance = value;
            }
        },

        sellAndMoveMoney: {
            cache: false,
            get(): number {
                return this.livedInPropertyCost + this.bankBalance;
            }
        },


    },

    data() {
        return new GameData();
    },

    methods: {

        resetMessages() {

            this.messagesLoaded = false;
            //Wait for 1000 ms before subscribing to reduce chance of error loading messages

            if (this.showChat) {

                this.advancedChatCount++;
                setTimeout(() => {
                    this.messagesLoaded = true;
                }, 1000);

            }

        },

        makeDaraNod(immediate: boolean) {

            if (this.playerState.roundState != roundstates.ChooseOption
                && this.playerState.roundState != roundstates.Storm
            ) {
                return;
            }

            this.daraNod++;
            this.daraNodImmediate = immediate;
        },

        resolveChoiceConflict(acceptedAction: boolean) {

            if (acceptedAction) {
                this.confirmClicked(true);
            }
            else {
                this.clearSelections(false, true);
            }
            this.choiceConflictText = "";

        },

        nextHint() {

            this.$emit("set-how-to-play", this.howToPlay + 1);

            //special case - last how to play also triggers chat
            if (this.howToPlay + 1 == this.maxHints - 1 && this.offline == false) {
                this.$emit("on-show-chat");
            }
        },

        completeHints() {
            this.$emit("set-how-to-play", this.maxHints);
        },

        cheat() {
            if (this.cheatEnabled) {
                this.bankBalance += 100;
            }
        },

        stopBankCost(seawallHeight: number, zeroIfBuilt: boolean, governmentSubsidy: boolean): number {
            return getStopBankCost(this.playerState, seawallHeight, zeroIfBuilt, governmentSubsidy);
        },

        TutorialDirection(dir: number) {

            const innerTextElements = document.getElementsByClassName("simplebar-content-wrapper");
            for (const element of innerTextElements) {
                element.scrollTop = 0;
            }

            switch (dir) {

                case -1:
                    this.$emit('previous-tutorial');
                    break;

                case 0:
                    this.$emit('finished-tutorial');
                    break;

                case 1:
                    this.$emit('next-tutorial');
                    break;

            }
        },

        onResize() {
            this.resizeCounter++;
            this.$emit('on-hide-chat');
        },

        //investments no longer allowed isInvestment: boolean
        canAffordAnyProperty(): boolean {

            for (const propertyId of Object.keys(properties)) {
                const propertyData = properties[propertyId];

                if (getBuyCost(propertyData) == 0) {
                    //We can't buy this anyway (Marae etc)
                    continue;
                }

                /*
                if (isInvestment) {
                    //We can't afford this
                    if (getBuyCost(propertyData) > this.bankBalance) {
                        continue;
                    }

                    //This is not a rental property anyway
                    if (getRentCost(propertyData) == 0) {
                        continue;
                    }

                }
                else {

                }
                */

                //We can't afford this
                if (getBuyCost(propertyData) > this.sellAndMoveMoney) {
                    continue;
                }

                //Does ANY player own this
                let alreadyOwned = false;
                for (const state of Object.values(this.game.playerStates)) {
                    for (const propertyState of state.properties) {

                        //Someone else owns this
                        if (propertyState.property == propertyId) {
                            alreadyOwned = true;
                            break;
                        }

                    }

                    if (alreadyOwned) {
                        break;
                    }
                }

                if (alreadyOwned) {
                    continue;
                }

                //We can afford at least one property
                return true;
            }

            return false;
        },


        requestVote(key: string, type: boolean | number): boolean {
            this.$emit(key, type);
            if (this.offline == false) {
                this.iRequestedVote = true;
            }
            return this.offline; //If we're in offline mode, move to the next round            
        },

        riverStateCheat(value: number): void {
            this.$emit('river-state-cheat', value);
        },

        stormStateCheat(value: number): void {
            this.$emit('storm-state-cheat', value);
        },

        availableButtons(): buttonState[] {

            switch (this.subMenu) {

                case SubMenu.relocateABuilding:
                    return this.relocateButtons(false);

                case SubMenu.relocateUrupa:
                    return this.relocateButtons(true);

                case SubMenu.raiseABuilding:
                    return this.raiseButtons();

                case SubMenu.protectPropertiesAndCommunity:
                    return this.protectButtons(true, true);

                case SubMenu.protectPropertiesAndCommunityRiver:
                    return this.protectButtons(true, false);

                case SubMenu.protectPropertiesAndCommunitySea:
                    return this.protectButtons(false, true);

                case SubMenu.sellAndMove:
                    return this.sellAndMoveButtons(false);

                case SubMenu.sellAndMoveElsewhere:
                    return this.sellAndMoveButtons(true);

                default:
                    return this.mainMenuButtons();
            }

        },

        upgradeableProperties(): { part: property_part, state: propertyPartState }[] {

            const result: { part: property_part, state: propertyPartState }[] = [];

            if (this.needsRepair) {
                return result;
            }

            for (const property of this.playerState.properties) {
                let propertyData = properties[property.property];

                for (let i = 0; i < propertyData.property_parts.length && i < property.propertyPartStates.length; i++) {
                    result.push({
                        part: propertyData.property_parts[i],
                        state: property.propertyPartStates[i],
                    });
                }

            }

            return result;

        },

        stopBankButton(result: buttonState[], seawallHeight: number) {

            //We can add a stop bank to this property

            if (this.stopBankCost(seawallHeight, false, this.game.governmentSubsidy) > 0) {

                const voteOnStopBankIndex = result.length;
                let stopBankButton: string;
                let stopBankText: string;

                let cost = this.stopBankCost(seawallHeight, true, this.game.governmentSubsidy);

                switch (seawallHeight) {

                    case 2:
                        if (this.offline) {
                            if (this.game.governmentSubsidy) {
                                stopBankText = this.pickText("choice_10_tui_marae_singleplayer_gvt", "choice_8_dara_farm_singleplayer_gvt", "choice_7_dara_town_singleplayer__gvt");
                            }
                            else {
                                stopBankText = this.pickText("choice_10_tui_marae_singleplayer", "choice_8_dara_farm_singleplayer", "choice_7_dara_town_singleplayer");
                            }
                        }
                        else {
                            if (this.game.governmentSubsidy) {
                                stopBankText = this.pickText("choice_10_tui_marae_multiplayer_gvt", "choice_8_dara_farm_multiplayer_gvt", "choice_7_dara_town_multiplayer_gvt");
                            }
                            else {
                                stopBankText = this.pickText("choice_10_tui_marae_multiplayer", "choice_8_dara_farm_multiplayer", "choice_7_dara_town_multiplayer");
                            }
                        }
                        stopBankButton = this.pickText("choice_10_marae", "choice_8_farm", "choice_7_town");
                        break;

                    case 1:
                        if (this.offline) {
                            if (this.game.governmentSubsidy) {
                                stopBankText = this.pickText("choice_9_tui_marae_singleplayer_gvt", "choice_7_dara_farm_singleplayer_gvt", "choice_6_dara_town_singleplayer__gvt");
                            }
                            else {
                                stopBankText = this.pickText("choice_9_tui_marae_singleplayer", "choice_7_dara_farm_singleplayer", "choice_6_dara_town_singleplayer");
                            }
                        }
                        else {
                            if (this.game.governmentSubsidy) {
                                stopBankText = this.pickText("choice_9_tui_marae_multiplayer_gvt", "choice_7_dara_farm_multiplayer_gvt", "choice_6_dara_town_multiplayer_gvt");
                            }
                            else {
                                stopBankText = this.pickText("choice_9_tui_marae_multiplayer", "choice_7_dara_farm_multiplayer", "choice_6_dara_town_multiplayer");
                            }
                        }
                        stopBankButton = this.pickText("choice_9_marae", "choice_7_farm", "choice_6_town");
                        break;

                    default: //River stop bank
                        if (this.offline) {
                            if (this.game.governmentSubsidy) {
                                stopBankText = this.pickText("choice_6_tui_marae_singleplayer_gvt", "choice_4_tui_farm_singleplayer_gvt", "choice_3_tui_town_singleplayer_gvt");
                            }
                            else {
                                stopBankText = this.pickText("choice_6_tui_marae_singleplayer", "choice_4_tui_farm_singleplayer", "choice_3_tui_town_singleplayer");
                            }
                        }
                        else {
                            if (this.game.governmentSubsidy) {
                                stopBankText = this.pickText("choice_6_tui_marae_multiplayer_gvt", "choice_4_tui_farm_multiplayer_gvt", "choice_3_tui_town_multiplayer_gvt");
                            }
                            else {
                                stopBankText = this.pickText("choice_6_tui_marae_multiplayer", "choice_4_tui_farm_multiplayer", "choice_3_tui_town_multiplayer");
                            }
                        }
                        stopBankButton = this.pickText("choice_6_marae", "choice_4_farm", "choice_3_town");
                        break;

                }

                let analyticsKey;
                if (this.offline) {
                    analyticsKey = "";
                }
                else {
                    switch (this.seaWallHeight) {
                        case 2:
                            analyticsKey = "Requested vote seawall2";
                            break;

                        case 1:
                            analyticsKey = "Requested vote seawall1";
                            break;

                        default:
                            analyticsKey = "Requested vote stopbank"
                            break;
                    }
                }

                result.push({
                    name: stopBankButton,
                    analyticsKey,
                    actionKey: "",
                    action: () => {

                        if (seawallHeight > 0) {
                            if (this.toggleButton(voteOnStopBankIndex, stopBankText, true)) {
                                this.seawallHeightSelected = this.playerState.seaWallHeight + seawallHeight;
                            }
                            else {
                                this.seawallHeightSelected = 0;
                            }
                        }
                        else {
                            this.stopBankSelected = this.toggleButton(voteOnStopBankIndex, stopBankText, true);
                        }
                    },
                    class: () => {

                        if (this.selectedButtons[voteOnStopBankIndex]) {
                            return "selection-button-highlighted";
                        }

                        //Costs too much?
                        if (cost == 0 || cost > this.availableCash) {
                            return "selection-button-disabled";
                        }

                        //Too much of a height upgrade
                        if ((seawallHeight && seawallHeight + this.playerState.seaWallHeight > 2)) {
                            return "selection-button-disabled";
                        }

                        //Other seawall option selected
                        if ((seawallHeight && this.seawallHeightSelected && seawallHeight != this.seawallHeightSelected)
                            //Nature based sea solution selected
                            || (seawallHeight && this.natureBasedSeaSelected)) {
                            return "selection-button-disabled";
                        }

                        //Other nature based selected
                        if (this.natureBasedSelected && seawallHeight == 0) {
                            return "selection-button-disabled";
                        }

                        return "selection-button";
                    },

                    value: () => cost,
                    valueString: () => roundedValue(cost, true),

                    completionAction: () => {

                        //Conflict!
                        if (this.playerState.natureBasedSeaSolution
                            && seawallHeight > 0
                            && !this.choiceConflictText) {
                            this.choiceConflictText = T("Choice_build_seawall_nature_modal");
                            return false;
                        }

                        return this.requestVote("request-stopbank", seawallHeight);

                    },

                });
            }

        },

        canBuyAnyProperty(): boolean {
            for (const propertyId of Object.keys(properties)) {
                const propertyData = properties[propertyId];
                //We can't buy or sell this property anyway
                if (canBuyOrSellProperty(this.subMenu, propertyData, this.playerState) === false) {
                    continue;
                }

                //*Someone* owns this
                if (doesAnyoneOwnThisProperty(propertyData, this.game)) {
                    continue;
                }
                return true;
            }
            return false;
        },

        sellAndMoveButtons(elsewhere: boolean): buttonState[] {

            const result: buttonState[] = [];
            const classKeys: { [key: string]: boolean } = {};

            //Prevent from moving into a different type of the player's current property
            classKeys[this.myOwnedProperty.classKey] = true;

            for (const propertyId of Object.keys(properties)) {

                const propertyData = properties[propertyId];

                //This doesn't match our elsewhere request
                if (elsewhere !== propertyData.elsewhere) {
                    continue;
                }

                //We can't buy or sell this property anyway
                if (canBuyOrSellProperty(elsewhere ? SubMenu.sellAndMoveElsewhere : SubMenu.sellAndMove, propertyData, this.playerState) === false) {
                    continue;
                }

                //*Someone* owns this
                if (doesAnyoneOwnThisProperty(propertyData, this.game)) {
                    continue;
                }

                //We're already offering one of this type of property
                if (classKeys[propertyData.classKey]) {
                    continue;
                }
                classKeys[propertyData.classKey] = true;

                const index = result.length;
                result.push({
                    name: getSellPropertyButton(T, propertyData),
                    actionKey: getSellPropertyReport(T, propertyData),
                    analyticsKey: getSellPropertyReport(T, propertyData),
                    class: () => {

                        if (this.selectedButtons[index]) {
                            return "selection-button-highlighted";
                        }
                        if (getBuyCost(propertyData) > this.sellAndMoveMoney) {
                            return "selection-button-disabled";
                        }
                        return "selection-button";

                    },
                    value: () => {
                        return getBuyCost(propertyData);
                    },
                    valueString: () => roundedValue(getBuyCost(propertyData), true),
                    action: () => {
                        this.clearSelections(true, false); //Disallow multiple purchases
                        propertyData.buySelected = this.toggleButton(index, getSellPropertyText(T, propertyData), false);
                    },
                    completionAction: () => {
                        this.powerup();
                        buyProperty(this.playerState, propertyData, this.playerState.livedInProperty, true);
                        return true;
                    },
                });

            }
            return result;
        },

        //helper method to simplify showing different text to different kinds of players
        pickText(maraeKey: string, farmKey: string, townshipKey: string): string {

            if (this.isMarae) {
                return T(maraeKey);
            }
            else if (this.isFarm) {
                return T(farmKey);
            }
            return T(townshipKey);

        },

        protectButtons(riverOptions: boolean, seaOptions: boolean): buttonState[] {

            const result: buttonState[] = [];
            if (this.needsRepair) { //Can't do any protection if we need to repair
                return result;
            }

            //We can add a nature based solution
            if (riverOptions) {

                //River based stop bank
                this.stopBankButton(result, 0);
                let cost = getNatureBasedCost(this.playerState, false, this.game.governmentSubsidy);

                if (cost > 0) {

                    if (this.playerState.isMakingNatureBasedSolution) {
                        cost = 0;
                    }

                    const name = this.pickText("choice_7_marae", "choice_5_farm", "choice_4_town");
                    const voteOnNatureBasedIndex = result.length;

                    result.push({
                        name,
                        analyticsKey: this.offline ? "" : "Requested vote nature based (river)",
                        actionKey: "",
                        action: () => {

                            let selectionText: string;

                            if (this.offline) {
                                if (this.game.governmentSubsidy) {
                                    selectionText = this.pickText("choice_7_tui_marae_multiplayer_gvt", "choice_5_dara_farm_multiplayer_gvt", "choice_4_dara_town_multiplayer_gvt");
                                }
                                else {
                                    selectionText = this.pickText("choice_7_tui_marae_multiplayer", "choice_5_dara_farm_multiplayer", "choice_4_dara_town_multiplayer");
                                }
                            }
                            else {
                                if (this.game.governmentSubsidy) {
                                    selectionText = this.pickText("choice_7_tui_marae_singleplayer_gvt", "choice_5_dara_farm_singleplayer_gvt", "choice_4_dara_town_singleplayer_gvt");
                                }
                                else {
                                    selectionText = this.pickText("choice_7_tui_marae_singleplayer", "choice_5_dara_farm_singleplayer", "choice_4_dara_town_singleplayer");
                                }
                            }

                            this.natureBasedSelected = this.toggleButton(voteOnNatureBasedIndex, selectionText, true);

                        },

                        class: () => {

                            if (this.selectedButtons[voteOnNatureBasedIndex]) {
                                return "selection-button-highlighted";
                            }

                            //Costs too much?
                            //this.disableNatureBasedSolution || 
                            if (cost > this.availableCash || cost == 0) {
                                return "selection-button-disabled";
                            }

                            //We're opting to build a stopbank
                            if (this.stopBankSelected) {
                                return "selection-button-disabled";
                            }

                            return "selection-button";
                        },

                        value: () => cost,
                        valueString: () => roundedValue(cost, true),

                        completionAction: () => {
                            return this.requestVote("request-nature-based-solution", false);
                        },

                    });
                }
            }

            //We can add a nature based sea solution
            if (seaOptions) {

                let cost = getNatureBasedCost(this.playerState, true, this.game.governmentSubsidy);
                if (cost) {

                    if (this.playerState.natureBasedSeaSolution) {
                        cost = 0;
                    }

                    const name = this.pickText("choice_8_marae", "choice_6_farm", "choice_5_town");

                    const voteOnNatureBasedSeaIndex = result.length;
                    result.push({
                        name,
                        analyticsKey: this.offline ? "" : "Requested vote nature based (sea)",
                        actionKey: "",
                        action: () => {

                            let selectionText = "";

                            if (this.offline) {


                                if (this.game.governmentSubsidy) {
                                    selectionText = this.pickText("choice_8_tui_marae_multiplayer_gvt", "choice_6_dara_farm_singleplayer_gvt", "choice_5_dara_town_singleplayer__gvt");
                                }
                                else {
                                    selectionText = this.pickText("choice_8_tui_marae_multiplayer", "choice_6_dara_farm_singleplayer", "choice_5_dara_town_singleplayer");
                                }

                            }
                            else {

                                if (this.game.governmentSubsidy) {
                                    selectionText = this.pickText("choice_8_tui_marae_singleplayer_gvt", "choice_6_dara_farm_multiplayer_gvt", "choice_5_dara_town_multiplayer_gvt");
                                }
                                else {
                                    selectionText = this.pickText("choice_8_tui_marae_singleplayer", "choice_6_dara_farm_multiplayer", "choice_5_dara_town_multiplayer");
                                }

                            }

                            this.natureBasedSeaSelected = this.toggleButton(voteOnNatureBasedSeaIndex, selectionText, true);
                        },

                        class: () => {

                            if (this.selectedButtons[voteOnNatureBasedSeaIndex]) {
                                return "selection-button-highlighted";
                            }

                            //Costs too much OR  or have selected to make a seawall
                            if (cost == 0 || cost > this.availableCash || this.seawallHeightSelected > 0) {
                                return "selection-button-disabled";
                            }

                            return "selection-button";
                        },

                        value: () => cost,
                        valueString: () => roundedValue(cost, true),

                        completionAction: () => {

                            //If there's a seawall already, we replace that text
                            if (this.playerState.seaWallHeight && !this.choiceConflictText) {
                                this.choiceConflictText = T("Choice_build_nature_seawall_modal");
                                return false;
                            }

                            return this.requestVote("request-nature-based-solution", true);
                        },

                    });
                }

                this.stopBankButton(result, 1);
                this.stopBankButton(result, 2);
            }

            //Drainage and pump
            if (getPumpCost(this.playerState, false) > 0) {

                const cost = getPumpCost(this.playerState, true);

                //we can buy a pump for this player
                const drainagePumpIndex = result.length;
                result.push({
                    name: T("install_drainage_and_pump"),
                    analyticsKey: "Installed drainage and pump",
                    actionKey: "",
                    action: () => {
                        this.drainagePumpSelected = this.toggleButton(drainagePumpIndex, T("install_drainage_and_pump"), false);
                    },
                    class: () => {

                        if (this.selectedButtons[drainagePumpIndex]) {
                            return "selection-button-highlighted";
                        }

                        //Costs too much OR
                        if (cost == 0 || cost > this.availableCash) {
                            return "selection-button-disabled";
                        }

                        return "selection-button";
                    },

                    value: () => cost,
                    valueString: () => roundedValue(cost, true),

                    completionAction: () => {
                        this.powerup();
                        this.bankBalance -= cost;
                        for (const property of this.playerState.properties) {
                            if (property.property == this.playerState.livedInProperty) {
                                property.hasDrainagePump = true;
                            }
                        }
                        return false;
                    },
                });
            }

            return result;
        },

        relocateButtons(includeUrupa: boolean): buttonState[] {

            const result: buttonState[] = [];

            for (const data of this.upgradeableProperties()) {

                let propertyPartData = data.part;
                let propertyPartState = data.state;
                let cost = getMoveCost(propertyPartData);

                //Special urupa menu
                if ((propertyPartData.damageClass == "urupa") != includeUrupa) {
                    continue;
                }

                //Can we move back?
                if (cost) {

                    //already moved
                    if (propertyPartState.isMoving) {
                        cost = 0;
                    }

                    const index = result.length;
                    result.push({
                        name: getMoveButtonText(T, this.playerState, propertyPartData, propertyPartState),
                        analyticsKey: getMoveReportText(T, this.playerState, propertyPartData, propertyPartState),
                        actionKey: getMoveReportText(T, this.playerState, propertyPartData, propertyPartState),
                        action: () => {
                            propertyPartData.moveSelected = this.toggleButton(index, getMoveSelectionText(T, this.playerState, propertyPartData, propertyPartState), false);
                        },
                        class: () => {
                            if (this.selectedButtons[index]) {
                                return "selection-button-highlighted";
                            }

                            //Costs too much?
                            if (cost == 0 || cost > this.availableCash) {
                                return "selection-button-disabled";
                            }

                            return "selection-button";
                        },
                        value: () => cost,
                        valueString: () => roundedValue(cost, true),
                        completionAction: () => {

                            this.powerup();
                            this.setDefaultText(getMovePost(T, this.playerState, propertyPartData, propertyPartState));
                            this.playerState.bankBalance -= cost;
                            propertyPartState.isMoving = true;
                            return true;

                        },
                    });

                }
            }
            return result;
        },

        powerup() {
            this.$emit("powerup");
        },

        raiseButtons(): buttonState[] {

            const result: buttonState[] = [];
            for (const data of this.upgradeableProperties()) {

                let propertyPartData = data.part;
                let propertyPartState = data.state;

                //We can't raise this if it's under water
                if (propertyPartIsUnderwater(this.playerState, data.part, data.state)) {
                    continue;
                }

                let movePosition = propertyPartState.movePosition;
                if (propertyPartState.isMoving) {
                    movePosition = 1;
                }

                //                const isMovingHouse = propertyPartData.moveSelected;

                //Can we raise the floor?
                let cost = getRaiseCost(propertyPartData)
                if (cost > 0) { // && ! {

                    const index = result.length;
                    if (propertyPartState.hasRaisedFloor[movePosition]) {
                        cost = 0; //Set cost to 0 if already bought
                    }

                    result.push({
                        name: getRaiseButtonText(T, propertyPartData),
                        analyticsKey: getRaiseReportText(T, propertyPartData),
                        actionKey: getRaiseReportText(T, propertyPartData),
                        action: () => {
                            propertyPartData.raiseSelected = this.toggleButton(index, getRaiseSelectionText(T, propertyPartData), false);
                        },
                        class: () => {

                            //if (hasAlreadyRaisedHouse && !isMovingHouse) {
                            //    return "selection-button-invisible";
                            //}
                            if (this.selectedButtons[index]) {
                                return "selection-button-highlighted";
                            }
                            //Costs too much or already bought?
                            if (cost == 0 || cost > this.availableCash) {
                                return "selection-button-disabled";
                            }
                            return "selection-button";
                        },

                        value: () => cost,
                        valueString: () => roundedValue(cost, true),

                        completionAction: () => {

                            this.powerup();
                            this.setDefaultText(getRaisePost(T, propertyPartData));
                            this.playerState.bankBalance -= cost;
                            let movePosition = propertyPartState.movePosition;

                            if (propertyPartState.isMoving) {
                                movePosition = 1;
                            }

                            propertyPartState.hasRaisedFloor[movePosition] = true;
                            return true;

                        },
                    });

                }
            }

            return result;

        },

        valueRangeString(result: buttonState[]): string {

            if (!result.length) {
                return "";
            }

            let min = Number.MAX_VALUE;
            let max = 0;
            for (const r of result) {
                const value = r.value();
                if (value > 0) {
                    min = Math.min(min, value);
                    max = Math.max(max, value);
                }
            }

            if (max == 0) {
                return "✓";
            }

            if (min == max) {
                //Not a range, just one value
                return roundedValue(min, true);
            }

            return roundedValue(min, true) + "-" + roundedValue(max);

        },

        mainMenuButtons(): buttonState[] {

            const result: buttonState[] = [];

            const actionsToCheck: buttonState[] = [];

            //Raise house button needed?
            const raiseButtons = this.raiseButtons();
            if (raiseButtons.length) { //temporary force

                actionsToCheck.push(...raiseButtons);

                result.push({
                    name: T("raise_a_building"),
                    analyticsKey: "",
                    actionKey: "",
                    value: () => 0,
                    valueString: () => this.valueRangeString(raiseButtons),
                    class: () => "selection-button",
                    action: () => this.subMenu = SubMenu.raiseABuilding,
                    completionAction: () => true,
                });

            }

            const moveButtons = this.relocateButtons(false);
            if (moveButtons.length) {

                actionsToCheck.push(...moveButtons);

                result.push({
                    name: anySalvagablePropertyPart(this.playerState)
                        ? T("salvage_rebuild") : T("relocate_a_building"),
                    analyticsKey: "",
                    actionKey: "",
                    value: () => 0,
                    valueString: () => this.valueRangeString(moveButtons),
                    class: () => "selection-button",
                    action: () => this.subMenu = SubMenu.relocateABuilding,
                    completionAction: () => true,
                });
            }

            const moveUrupaButtons = this.relocateButtons(true);
            if (moveUrupaButtons.length) {

                actionsToCheck.push(...moveUrupaButtons);

                result.push({
                    name: T("relocate_urupa"),
                    analyticsKey: "",
                    actionKey: "",
                    value: () => 0,
                    valueString: () => this.valueRangeString(moveUrupaButtons),
                    class: () => "selection-button",
                    action: () => this.subMenu = SubMenu.relocateUrupa,
                    completionAction: () => true,
                });
            }

            if (this.isMarae) {

                const riverButtons = this.protectButtons(true, false);
                actionsToCheck.push(...riverButtons);

                if (riverButtons.length) {
                    result.push({
                        name: T("protect_from_river_floods"),
                        analyticsKey: "",
                        actionKey: "",
                        value: () => 0,
                        valueString: () => this.valueRangeString(riverButtons),
                        class: () => "selection-button",
                        action: () => this.subMenu = SubMenu.protectPropertiesAndCommunityRiver,
                        completionAction: () => true,
                    });
                }

                const seaButtons = this.protectButtons(false, true);
                actionsToCheck.push(...seaButtons);

                if (seaButtons.length) {
                    result.push({
                        name: T("protect_from_storm_surges"),
                        analyticsKey: "",
                        actionKey: "",
                        value: () => 0,
                        valueString: () => this.valueRangeString(seaButtons),
                        class: () => "selection-button",
                        action: () => this.subMenu = SubMenu.protectPropertiesAndCommunitySea,
                        completionAction: () => true,
                    });
                }
            }
            else {

                const protectButtons = this.protectButtons(true, true);
                actionsToCheck.push(...protectButtons);

                if (protectButtons.length) {
                    result.push({
                        name: T("protect_properties_and_community"),
                        analyticsKey: "",
                        actionKey: "",
                        value: () => 0,
                        valueString: () => this.valueRangeString(protectButtons),
                        class: () => "selection-button",
                        action: () => this.subMenu = SubMenu.protectPropertiesAndCommunity,
                        completionAction: () => true,
                    });
                }
            }

            if (this.isMarae == false && this.cowShedNeedsRepair == false) {

                const sellAndMoveButtons = this.sellAndMoveButtons(false);
                actionsToCheck.push(...sellAndMoveButtons);

                if (sellAndMoveButtons.length) {
                    result.push({
                        name: this.livingWithRelatives ? T("forced_city_buy_back_coast") : this.pickText("", "sell_and_move_farm", "choice_8_town"),
                        analyticsKey: "",
                        actionKey: "",
                        value: () => 0,
                        valueString: () => this.valueRangeString(sellAndMoveButtons),
                        class: () => "selection-button",
                        action: () => this.subMenu = SubMenu.sellAndMove,
                        completionAction: () => true,
                    });
                }

                const sellAndMoveElsewhereButtons = this.sellAndMoveButtons(true);
                actionsToCheck.push(...sellAndMoveElsewhereButtons);

                if (sellAndMoveElsewhereButtons.length) {
                    result.push({
                        name: this.livingWithRelatives ? T("forced_city_buy_city") : this.pickText("", "choice_10_farm", "choice_9_town"),
                        actionKey: "",
                        analyticsKey: "",
                        value: () => 0,
                        valueString: () => this.valueRangeString(sellAndMoveElsewhereButtons),
                        class: () => "selection-button",
                        action: () => this.subMenu = SubMenu.sellAndMoveElsewhere,
                        completionAction: () => true,
                    });
                }
            }

            //pad to six buttons
            while (result.length < 5) {
                result.push({
                    name: "",
                    actionKey: "",
                    analyticsKey: "",
                    class: () => "blank-button",
                    value: () => 0,
                    valueString: () => "",
                    action: () => { return; },
                    completionAction: () => { return false; },
                });
            }

            let doNothingButton: string;
            let doNothingDescription: string;
            let nextRoundDescription: string;

            //Base do nothing text
            if (this.isMarae) {
                doNothingButton = T("choice_11_marae");
                doNothingDescription = T("Choice_11_tui__marae");
                nextRoundDescription = T("Choice_11_tui__next_round_marae");
            }
            else if (this.isFarm) {
                doNothingButton = T("choice_11_farm");
                doNothingDescription = T("Choice_11_tui__farm");
                nextRoundDescription = T("Choice_11_tui__next_round_farm");
            }
            else {
                doNothingButton = T("choice_10_town");
                doNothingDescription = T("Choice_10_tui_town");
                nextRoundDescription = T("Choice_10_tui__next_round_town");
            }

            if (this.needsRepair && this.bankBalance >= this.repairCost) {
                doNothingButton = T("button_forcedrepairs_damagedcowshed");
            }
            else if (this.actionsThisRound) {
                doNothingButton = T("end_turn");
                doNothingDescription = T("end_turn_tui");
            }

            result.push({
                name: doNothingButton,
                analyticsKey: "",
                actionKey: "",
                action: () => {

                    this.daraWaitMessage = doNothingDescription;

                    if (nextRoundDescription) {
                        this.setDefaultText(nextRoundDescription, false);
                    }

                    this.progressGame();

                },

                class: () => {
                    if (this.actionsThisRound) {
                        return "selection-button-end-turn";
                    }
                    return "selection-button";
                },
                value: () => 0,
                valueString: () => "",
                completionAction: () => {

                    return true;
                },
            });


            //Is it time to remember which actions we had available at the start of the choose option phase
            if (this.actionsAvailable.length <= this.playerState.round && this.isMyTurn) {


                //Make sure we haven't skipped any rounds for any reason
                while (this.actionsAvailable.length < this.playerState.round - 1) {
                    this.actionsAvailable.push([]);
                }
                let newActionsAvailable: string[] = [];

                for (const button of actionsToCheck) {

                    //This button is not disabled, so we can treat this as an available option
                    if (button.class() !== "selection-button-disabled") {
                        newActionsAvailable.push(button.name);
                    }
                }

                this.actionsAvailable.push(newActionsAvailable);


            }

            return result;
        },

        setDefaultText(text: string, forced = true) {
            this.$emit("set-default-text", text, forced);
        },

        dismissVoteResult() {

            /*
            if (this.noVotes === 0 //This was a unanimous vote
                && this.iRequestedVote //It was me that requested it
                && this.isMyTurn //Sanity check
                && this.playerState.roundState == roundstates.ChooseOption) //Sanity check
            {
                this.progressGame();
            }
                */

            this.iRequestedVote = false;
            this.$emit('dismissed-vote-results');
        },

        closeDonation() {
            this.donateBox = false;
        },

        onDonate(donateTo: { [id: string]: number }) {
            this.closeDonation();
            this.$emit("on-donate", donateTo);
        },

        OnVote(result: boolean) {
            this.$emit("on-vote", result);
        },

        /*
        clearDoNothing() {
         
            //Clear the "do nothing" button            
            this.clearButton(doNothingIndex);
         
            //In single player, we want to allow stop bank and nature based to be selected concurrently as there is no voting round
            if (this.offline == false) {
                this.clearButton(voteOnNatureBasedIndex);
                this.clearButton(voteOnStopBankIndex);
                this.natureBasedSelected = this.stopBankSelected = false;
            }
         
        },
        */

        roundedValue(value: number): string {
            return roundedValue(value);
        },

        T(key: string): string {
            return T(key);
        },

        clearSelections(clearTodoOverride: boolean, returnHome: boolean) {
            this.selectedButtons = {};
            for (const property of Object.values(properties)) {

                property.buySelected = false;

                for (const propertyPart of property.property_parts) {
                    propertyPart.raiseSelected = false;
                    propertyPart.moveSelected = false;
                }
            }

            this.seawallHeightSelected = 0;
            this.stopBankSelected = false;
            this.natureBasedSelected = false;
            this.natureBasedSeaSelected = false;

            if (clearTodoOverride) {
                this.todoOverrideText = "";
            }
            if (returnHome) {
                this.subMenu = SubMenu.main;
            }
        },

        setButton(index: number) {
            Vue.set(this.selectedButtons, index, true);
        },

        toggleButton(index: number, overrideText = "", voteable: boolean): boolean {

            if (this.selectedButtons[index]) {
                this.clearButton(index);
                if (this.todoOverrideText == overrideText) {
                    this.todoOverrideText = "";
                }
                return false;
            }
            else {
                if (voteable && this.offline == false) {
                    //If it's voteable, we only want to allow one option at a time
                    this.clearSelections(true, false);
                }
                this.setButton(index);
                this.todoOverrideText = overrideText;
                return true;
            }
        },

        clearButton(index: number) {
            if (index < 0) {
                return;
            }
            Vue.delete(this.selectedButtons, index);
            this.internalUpdates += 1; //Force a refresh
        },

        backClicked() {
            this.clearSelections(true, true);
        },

        confirmClicked(acceptedConflict) {

            let buttons = this.buttons;
            //Backwards because move MUST be done before RAISE
            for (let i = buttons.length - 1; i >= 0; i--) {
                if (this.selectedButtons[i]) {

                    buttons[i].completionAction();

                    //                if (buttons[i].completionAction() == false) {
                    //Requested a vote etc prevents moving on (STILL NEEDED?)
                    //                      canContinue = false;
                    //                    }

                    //If we have an action key, add it to the list for the report
                    doPlayerAction(this.playerState, buttons[i].actionKey, buttons[i].analyticsKey, maxRounds);
                    this.$emit("update-game");

                }
            }

            if (this.choiceConflictText && !acceptedConflict) {
                //we've got a conflict to resolve!
                return;
            }

            //Empty the list of properties moved this round
            this.clearSelections(false, true);

            //Update the game anyway in order to keep results of decisions such as buying property
            this.$emit("update-game");
            this.actionsThisRound++;
            this.backClicked();
        },

        progressGame() {

            //Special case - trigger landslide sound
            if (this.playerState.roundState == roundstates.RollTheDice
                && this.riverStage == 2) {
                this.$emit("trigger-landslide-sound");
            }

            this.clearSelections(true, true);

            //We send the report once we've dismissed the round report
            if (this.playerState.roundState == roundstates.RoundReport) {

                this.$emit('analytics-report', this.actionsAvailable[this.playerState.round]);

            }

            //we can progress if we're on the main submenu
            this.$emit('progress-game');
            this.actionsThisRound = 0;
            this.makeDaraNod(this.playerState.roundState != roundstates.ChooseOption);
            this.resetMessages();

        }
    },

    mounted() {

        const rooms: room[] = [];
        const newRoom = new room();
        const roomUsers: room_user[] = [];

        for (let i = 0; i < users.length; i++) {

            //Skip this player if the player is not in the game
            if (!this.game.playerStates[i]) {
                continue;
            }

            //Clean clone of the user
            let user = JSON.parse(JSON.stringify(users[i]));
            user._id = T(user.realname);
            user.username = T(user.realname);
            roomUsers.push(user);

        }

        newRoom.users = roomUsers;

        rooms.push(newRoom);
        this.rooms = rooms;

        //Force the chat to be closed at the very start, but force it to pop up if another player has sent messages
        if (this.showChat) {
            this.$emit('on-hide-chat');
            setTimeout(() => {
                this.$emit('on-show-chat');
            }, 1000);
        }

    }


});
</script>

<style lang="less">
.donation-received-inner {
    position: absolute;
    width: 100%;
    height: 100%;
    padding-top: 32px;
    padding-left: 32px;
    padding-right: 32px;
    color: #636252;
}

.donation-received-header {
    font-family: Rubik;
    font-size: 30px;
    font-weight: 800;
    line-height: 35.55px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

}

.donation-received-text {
    font-family: Rubik;
    font-size: 16px;
    font-weight: 400;
    line-height: 18.96px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin-top: 23px;
}

.donation-received-btn {
    border-radius: 8px;
    background-color: #B2CD30;
    cursor: pointer;
    color: white;
    position: absolute;
    bottom: 30px;
    width: 162px;
    height: 50px;
    font-family: Rubik;
    font-size: 14px;
    font-weight: 800;
    line-height: 16.59px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    display: flex;
    justify-content: center;
    align-items: center;
}

.hint-indicator {
    background-image: url("../assets-fca/UI/hint_indicator.svg");
    width: 47px;
    height: 47px;
    position: absolute;
}

.hint-indicator-0 {
    .hint-indicator;
    left: 107px;
    bottom: 367.95px;
}

.hint-indicator-1 {
    .hint-indicator;
    left: 59px;
    top: -50px;
}

.hint-indicator-2-a {
    .hint-indicator;
    left: 381px;
    top: -46px;
}

.hint-indicator-2-b {
    .hint-indicator;
    left: 526px;
    top: -46px;
}

.hint-indicator-3 {
    .hint-indicator;
    left: 67px;
    top: -58px;
}

.hint-indicator-4 {
    .hint-indicator;
    rotate: -90deg;
    right: 136px;
    top: 7px;
}

.btn-storm {
    position: absolute;
    width: 100px;
    height: 40px;
    left: 172.33px;
    top: 99.02px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #B2CD30;
    color: #636252;
    border-radius: 8px;
    font-family: Rubik;
    font-size: 18px;
    font-weight: 700;
    line-height: 21.33px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    cursor: pointer;
}

.facilitator-circle {
    background-image: url("../assets-fca/Guide/facilitator-circle.svg");
    position: absolute;
    width: 169px;
    height: 169px;
}

.facilitator-circle-0 {
    .facilitator-circle;
    transform: scale(-1, 1);
    top: 117px;
    left: 520px;
}

.facilitator-circle-donation-received {
    .facilitator-circle;
    top: -185px;
    left: 117px;
}

.facilitator-circle-1 {
    .facilitator-circle;
    top: -185px;
    left: 117px;
}

.facilitator-circle-2 {
    .facilitator-circle;
    top: 113px;
    left: -177px;
}

.facilitator-circle-3 {
    .facilitator-circle;
    top: 117px;
    left: 520px;
    transform: scale(-1, 1);
}

.facilitator-circle-4 {
    .facilitator-circle;
    top: 113px;
    left: -177px;
}


.facilitator-circle-choice-conflict {
    .facilitator-circle;
    top: -185px;
    left: 117px;
}

.facilitator-tick-0 {
    left: 487px;
    top: 147px;
    rotate: 90deg;
}

.facilitator-tick-1 {
    top: -26px;
    left: 176px;
}

.facilitator-tick-2 {
    top: 147px;
    left: -26px;
    rotate: -90deg;
}

.facilitator-tick-3 {
    top: 147px;
    left: 487px;
    rotate: 90deg;
}

.facilitator-tick-4 {
    top: 147px;
    left: -26px;
    rotate: -90deg;
}

.facilitator-tick-donation-received {
    top: -26px;
    left: 176px;
}


.facilitator-tick-choice-conflict {
    top: -26px;
    left: 176px;
}


.facilitator-header-left {
    height: 19px;
    top: 40px;
    left: 32px;
    position: absolute;
    font-family: Rubik;
    font-size: 16px;
    font-weight: 800;
    line-height: 18.96px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #636252;
}

.facilitator-header-right {
    .facilitator-header-left;
    left: unset;
    right: 32px;
}

.facilitator-text {
    font-family: Rubik;
    font-size: 16px;
    font-weight: 400;
    line-height: 18.96px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #333333;
    position: absolute;
    top: 75px;
    left: 32px;
    right: 32px;
}

.facilitator-next-btn {
    position: absolute;
    width: 162px;
    height: 50px;
    left: 32px;
    bottom: 40px;
    background-color: #B2CD30;
    font-family: Rubik;
    font-size: 14px;
    font-weight: 800;
    line-height: 16.59px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #fff;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.facilitator-skip-btn {
    .facilitator-next-btn;
    left: 210px;
    background-color: #F1A738;
}

.simplebar-vertical {
    background-color: #DEDEC7;
    border-radius: 100px;
    height: 80px;
    position: absolute;
    top: 6px !important;
    width: 4px !important;
}

.simplebar-scrollbar.simplebar-visible:before {
    opacity: 1 !important;
}

.simplebar-scrollbar {
    left: -0.5px;
    right: -0.5px;
    top: -1px;
    bottom: 1px;
}

.selection-button:hover {
    border: solid #979797 !important;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.control-panel {
    background-image: url("../assets-fca/UI/Control_Panel_Base.svg");
    position: absolute;
    width: 1068px;
    height: 202px;
    left: 50%;
    margin-left: -534px;
    bottom: 8px;
    background-size: contain;
    background-repeat: no-repeat;
    animation: control-panel-anim 1s;
}

@keyframes control-panel-anim {
    0% {
        bottom: -202px;
    }

    100% {
        bottom: 8px;
    }
}

.guide-outer {
    background-image: url("../assets-fca/Guide/guide_speech_only.svg");
    position: absolute;
    width: 317px;
    height: 352.95px;
    left: 4px;
    top: 460px;
    animation: guide-anim 1s;
}

.guide-about-area {
    position: absolute;
    width: 20px;
    height: 25px;
    right: 18px;
    top: 0px;
    cursor: pointer;
    pointer-events: auto;
}

.guide-inner {
    position: absolute;
    width: 150px;
    height: 146.5px;
    background-image: url("../assets-fca/Guide/guide_no_speech.svg");
    left: 21px;
    top: 162px;
    transform-origin: 32% 92%;
    animation: guide-inner-anim 1s;
    animation-delay: 3s;
}

.guide-inner-animate-immediately {
    animation-delay: 0s;
}

@keyframes guide-anim {
    0% {
        left: -317px;
    }

    100% {
        left: 4px;
    }
}

@keyframes guide-inner-anim {

    0% {
        transform: rotate(0deg)
    }

    33% {
        transform: rotate(-5deg)
    }

    66% {
        transform: rotate(5deg)
    }

    100% {
        transform: rotate(0deg)
    }
}



.control-panel-hazard-map {
    background-image: url("../assets-fca/UI/hazard_map_base.svg");
    position: absolute;
    width: 601px;
    height: 47px;
    top: 1px;
    left: 464px;
}

.hazard-toggle-river {
    .hazard-toggle-off;
    top: 16px;
    left: 505px;
}

.hazard-toggle-sea {
    .hazard-toggle-off;
    top: 16px;
    left: 364px;
}

.hazard-toggle-on {
    background-image: url("../assets-fca/UI/hazard_map_toggle_on.svg");
}

.hazard-toggle-off {
    position: absolute;
    cursor: pointer;
    width: 46px;
    height: 20px;
    background-image: url("../assets-fca/UI/hazard_map_toggle_off.svg");
}

.control-panel-action-text {
    width: 78px;
    height: 24px;
    top: 25px;
    left: 43px;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Rubik;
    font-size: 20px;
    font-weight: 800;
    line-height: 23.7px;
    letter-spacing: -0.4180000126361847px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #636252;
}

.control-panel-button-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    position: absolute;
    top: 63px;
    left: 22px;
    width: 1025px;
    column-gap: 12px;
    row-gap: 12px;
}

.selection-button {
    width: 333.67px;
    height: 50px;
    border-radius: 8px;
    background-color: #DEDEC7;
    color: #636252;
    font-family: Rubik;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 17px;
    border: 0;
    text-align: left;
    margin-bottom: 5px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    border: solid #ffffff00;
    padding: -1px;
}

.selection-button-end-turn {
    .selection-button;
    background-color: #B2CD30;
}

.blank-button {
    .selection-button;
    opacity: 0;
}

.selection-button-highlighted {
    .selection-button;
    background-color: #636252;
    color: #FFFFFF;
}

.selection-button-disabled {
    .selection-button;
    opacity: 0.5;
    pointer-events: none;
    cursor: default;
}

.selection-button-invisible {
    .selection-button;
    display: none;
    pointer-events: none;
    cursor: default;
}

.control-panel-submenu .selection-button {
    width: 275.67px;
}

.control-panel-submenu .selection-button-highlighted {
    width: 275.67px;
}

.control-panel-submenu .selection-button-disabled {
    width: 275.67px;
}

.control-panel-submenu .selection-button-invisible {
    width: 275.67px;
}

.control-panel-confirm-back-container {
    position: absolute;
    width: 162px;
    height: 112px;
    top: 63px;
    right: 19px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.control-panel-confirm-button {
    width: 162px;
    height: 50px;
    border-radius: 8px;
    background-color: #B2CD30;
    font-family: Rubik;
    font-size: 14px;
    font-weight: 800;
    line-height: 16.59px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0;
}

.control-panel-confirm-button-disabled {
    .control-panel-confirm-button;
    opacity: 0.5;
    pointer-events: none;
    cursor: default;
}

.control-panel-back-button {
    .control-panel-confirm-button;
    background-color: #F1A738;
}

@media (max-aspect-ratio: 3/2) {
    .control-panel {
        left: unset;
        margin-left: unset;
        right: 8px;
    }
}


.slr {
    position: absolute;
    width: 108px;
    height: 313px;
    right: 0px;
    top: 286px;
}

.slr-1 {
    background-image: url("../assets-fca/UI/SLR_1.svg");
}

.slr-2 {
    background-image: url("../assets-fca/UI/SLR_2.svg");
}

.slr-3 {
    background-image: url("../assets-fca/UI/SLR_3.svg");
}

.slr-4 {
    background-image: url("../assets-fca/UI/SLR_4.svg");
}

.slr-5 {
    background-image: url("../assets-fca/UI/SLR_5.svg");
}

.slr-6 {
    background-image: url("../assets-fca/UI/SLR_6.svg");
}

.slr-7 {
    background-image: url("../assets-fca/UI/SLR_7.svg");
}

.slr-8 {
    background-image: url("../assets-fca/UI/SLR_8.svg");
}



.donate-btn {

    position: absolute;
    width: 181px;
    height: 44px;
    top: 285px;
    left: 19px;
    padding: 12px 16px 12px 16px;


    border-radius: 8px;
    background-color: #B2CD30;
    color: #FFFFFF;
    font-family: Rubik;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.button-value {
    white-space: nowrap;
}

.simple-bar {
    position: absolute;
    top: 18px;
    left: 18px;
    width: 268px;
    height: 119px;
    font-family: Rubik;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.59px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    padding-right: 10px;
}

.simple-bar-tutorial {
    height: 140px !important;
}

.how-to-play-cover {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #40465E80;
    opacity: 0.5;
}


.round-overlay-base {
    position: absolute;
    width: 100%;
    height: 100%;
    pointer-events: none;
}

.round-base {
    position: absolute;
    top: -5px;
    bottom: -5px;
    left: -5px;
    right: -5px;
    background-size: cover;
    background-position: center;
    animation: roundOverlayFadeOutBackground 3s;
    opacity: 0;
    z-index: 1000;
}

.round-1 {
    .round-base;
    background-image: url("../assets-fca/UI/round_1.svg");
}

.round-2 {
    .round-base;
    background-image: url("../assets-fca/UI/round_2.svg");
}

.round-3 {
    .round-base;
    background-image: url("../assets-fca/UI/round_3.svg");
}

.round-4 {
    .round-base;
    background-image: url("../assets-fca/UI/round_4.svg");
}

.round-5 {
    .round-base;
    background-image: url("../assets-fca/UI/round_5.svg");
}

.round-6 {
    .round-base;
    background-image: url("../assets-fca/UI/round_6.svg");
}

.round-7 {
    .round-base;
    background-image: url("../assets-fca/UI/round_7.svg");
}

.round-8 {
    .round-base;
    background-image: url("../assets-fca/UI/round_8.svg");
}

.chat-offset {
    position: absolute;
    z-index: 9999;
    height: 433px;
    width: 220px;
    right: 8px;
    top: 59px;
}

.chat-tick {
    background-image: url("../assets-fca/UI/chat_speech_tick.svg");
    background-size: cover;
    position: absolute;
    width: 26px;
    height: 26px;
    left: 101.5px;
    top: -15px;
}

.hide-chat {
    opacity: 0;
    pointer-events: none;
    display: none;
}

.close-chat-btn {
    position: absolute;
    background-image: url("../assets-fca/UI/chat_close.svg");
    background-size: cover;
    top: 13px;
    right: 13px;
    width: 18px;
    height: 18px;
    z-index: 1000;
    cursor: pointer;
}

@keyframes roundOverlayFadeOutBackground {

    0% {
        opacity: 1;
    }

    75% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }

}

@keyframes roundOverlayFadeOut {

    0% {
        opacity: 1;
    }

    75% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }

}

.hazard-map-help-inner {
    position: absolute;
    top: 40px;
    left: 25px;
    right: 25px;
}

.hazard-map-help-inner-header {
    font-family: Rubik;
    font-weight: 800;
    font-size: 16px;
    line-height: 18.96px;
    letter-spacing: 0px;
    color: #636252;
    margin-bottom: 20px;
}

.hazard-map-help-inner-text {
    font-family: Rubik;
    font-weight: 400;
    font-size: 16px;
    line-height: 18.96px;
    letter-spacing: 0px;
}

.hazard-map-help-close {
    position: absolute;
    cursor: pointer;
    background-image: url("../assets-fca/UI/close_gray.svg");
    top: 40px;
    right: 50px;
    width: 16px;
    height: 16px;
}

.hazard-map-help-tick {
    position: absolute;
    left: 446px;
    top: 259px;
    rotate: 180deg;
}

.control-panel-hazard-map-info {
    position: absolute;
    left: 564px;
    top: 17px;
    width: 18px;
    height: 18px;
    background-image: url("../assets-fca/UI/hazard_map_info.svg");
    cursor: pointer;
}

.control-panel-hazard-map-header {
    position: absolute;
    top: 18px;
    left: 175px;
    font-family: Rubik;
    font-weight: 800;
    font-size: 14px;
    line-height: 16.59px;
    letter-spacing: 0%;
    color: white;
}

.control-panel-hazard-map-header {
    position: absolute;
    top: 18px;
    left: 175px;
    font-family: Rubik;
    font-weight: 800;
    font-size: 14px;
    line-height: 16.59px;
    letter-spacing: 0%;
    color: white;
}

.control-panel-hazard-map-sea {
    position: absolute;
    color: #636252;
    top: 16.5px;
    left: 321px;
    font-family: Rubik;
    font-weight: 800;
    font-size: 14px;
    line-height: 16.59px;
    letter-spacing: 0%;
}

.control-panel-hazard-map-river {
    .control-panel-hazard-map-sea;
    left: 451px;
}
</style>
